"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLeaseConfig = getLeaseConfig;
exports.updateLeaseConfig = updateLeaseConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function getLeaseConfig(params) {
  return (0, _request.default)({
    url: '/admin/lease/global/config/get',
    method: 'get',
    params: params
  });
}

/**
 * @param prams
 */
function updateLeaseConfig(data) {
  return (0, _request.default)({
    url: '/admin/lease/global/config/update',
    method: 'post',
    data: data
  });
}